import React from "react";
import gift from "../Assets/image 81.png";
function Shop() {
  return (
    <>
      <div className="ProfileStatus">
        <h3>Shop</h3>
        <br />
        <div className="plans-div">
          <div className="plans-cards">
            <div className="plans-card">
              <h4>Standard Plan</h4>
              <br />
              <img src={gift} />
              <br />
              <h3>Plan name : Standard</h3>
              <h3>Validity : 6 Months</h3>
              <h3>Valid till 24 June 2024 </h3>
              <br />
              <h2>Rs 2999</h2>
              <br />
              <button>Shop Now</button>
            </div>
            <div className="plans-card">
              <h4>Standard Plan</h4>
              <br />
              <img src={gift} />
              <br />
              <h3>Plan name : Standard</h3>
              <h3>Validity : 6 Months</h3>
              <h3>Valid till 24 June 2024 </h3>
              <br />
              <h2>Rs 2999</h2>
              <br />
              <button>Shop Now</button>
            </div>
            <div className="plans-card">
              <h4>Standard Plan</h4>
              <br />
              <img src={gift} />
              <br />
              <h3>Plan name : Standard</h3>
              <h3>Validity : 6 Months</h3>
              <h3>Valid till 24 June 2024 </h3>
              <br />
              <h2>Rs 2999</h2>
              <br />
              <button>Shop Now</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Shop;
